export const API_URL = 'https://api.openweathermap.org/data/2.5/weather/';
export const API_FORECAST_URL =
  'https://api.openweathermap.org/data/2.5/onecall';
export const IMAGE_URL = 'https://openweathermap.org/img/w/';

export const API_KEY = 'ece8396aded4725ff57b2feaf136adcb';
